import context from '@truckdown/components-systems';
import { IPromotionManager } from '@truckdown/promotions';
import { defineComponent, ref, Ref } from "vue";
import { showMessage } from '../../Utilities/utilities';

interface IData {
    isLoading: Ref<boolean>,
    showError: Ref<boolean>,
    promotionId: Ref<string>
};

const getInitialData = function (props: any) {
    return {
        isLoading: ref<boolean>(false),
        showError: ref<boolean>(false),
        promotionId: ref<String>(props.promotionid)
    } as IData;
}

const getMethods = function (data: IData, ctx: any) {
    return {
        removePromotionCancelClick: function (): void {
            ctx.emit(events.cancelled, false);
        },
        removePromotionSaveClick: async function (): Promise<void> {
            await removePromotion(data, ctx);
        }
    }
}

const removePromotion = async function (data: IData, ctx: any): Promise<void> {
    if (!data.isLoading.value) {
        data.isLoading.value = true;
        try {
            let mgr = await context.getService<IPromotionManager>('IPromotionManager');
            var response = await mgr.remove(data.promotionId.value);
            if (!response || !response.ok) {
                showMessage("Error removing promotion", "danger", true, true);
            } else {
                showMessage("Promotion was successfully removed.", "success", true, true);
                ctx.emit(events.updated);
            }
        } catch (err) {
            console.log(err);
            showMessage("Error removing promotion.", "danger", true, true);
        } finally {
            data.isLoading.value = false;
        }
    }
}

const events = {
    updated: 'update',
    cancelled: 'cancel'
}

export default defineComponent({
    props: {
        promotionid: String
    },
    emits: [events.updated, events.cancelled],
    setup: function (props, ctx) {

        let data = getInitialData(props);
        let methods = getMethods(data, ctx);

        return {
            ...data,
            ...methods
        };
    }
});